export default "__VITE_ASSET__CAptxlfD__"